export class PreviousAppointmentMedications {
    appointmentId: number;
    appointmentDateTime: string;
    encounterType: string;
    medications?: string;
}